import React, {useState, useEffect} from 'react';
import CenteredSpinner from '../spinners/centered-spinner';

const EntitySelector = ({className, id, label, fetchEntities, errorHandler, allowNull, hideWhenNoChoice, initialValue, onChange}) => {

  const [entities, setEntities] = useState();
  const [value, setValue] = useState(initialValue);

  useEffect(() => onChange(value ? value : null), [value]);

  useEffect(() => {
    fetchEntities()
      .then(entities => {
        const sanitizedEntities = entities || [];
        setEntities(sanitizedEntities);

        if (!value) {
          if (!allowNull && sanitizedEntities.length > 0) {
            setValue(sanitizedEntities[0].id);
          }
        } else {
          if (!sanitizedEntities.some(e => e.id === value)) {
            if (!allowNull && sanitizedEntities.length > 0) {
              setValue(sanitizedEntities[0].id);
            } else {
              setValue(null);
            }
          }
        }
      })
      .catch(err => {
        if (errorHandler) {
          errorHandler(err);
        } else {
          window.alert(err.stack || JSON.stringify(err));
        }
      });
  }, []);

  const wrapperClassName = () =>  {
    if (!className) {
      return 'mb-3';
    } else {
      return className + (className.indexOf('mb-') < 0 ? ' mb-3' : '');
    }
  }

  if (!entities) {
    return <>
      <CenteredSpinner/>
      {label && <div style={{height: '20px'}}/>}
    </>;
  } else if (hideWhenNoChoice && ((allowNull && entities.length === 0) || (!allowNull && entities.length <= 1))) {
    return <></>;
  } else {
    return <div className={wrapperClassName()}>
      {label &&
      <label htmlFor={id} className="form-label">{label}</label>
      }
      <select id={id}
              className="form-select"
              value={value || ''}
              onChange={e => setValue(e.target.value)}>
        {(allowNull || !value) && <option key="null" value={null}/>}
        {entities.map(entity =>
          <option key={entity.id} value={entity.id}>{entity.name}</option>
        )}
      </select>
    </div>;
  }

};

export default EntitySelector;
